module.exports = __webpack_public_path__ + "static/media/icon-update-kalyzee@3x.27de0417.jpg";